
/**
 * Делаем, чтобы когда tab header 1->2->3->4 становился sticky - то чтобы ему добавлялся стиль (чтобы тень появлялась)
 * то же самое и для кнопок "Далее"
 */
export function makeTabsStickyHeader() {
    let target = document.querySelector('.make-app .tabs-top-sticky-empty');
    if (target) {
        const observerTop = new IntersectionObserver((entries, observer) => {
            entries.map((entry) => {
                if (entry.target.className == 'tabs-top-sticky-empty') {
                    Array.prototype.slice.call(document.querySelectorAll('.make-app .nav')).map((element) => {
                        element.classList.toggle('sticky-active', !entry.isIntersecting)
                    });
                }
            })
        },  {
            root: null,
            rootMargin: '0px',
            threshold: 1
        });
        observerTop.observe(document.querySelector('.make-app .tabs-top-sticky-empty') as Element);

        ['themes', 'slides', 'music', 'payment'].map(tab => {
            const observerBottom = new IntersectionObserver((entries, observer) => {
                entries.map((entry) => {
                    Array.prototype.slice.call(document.querySelectorAll(`.footer-buttons.${tab}`)).map((element) => {
                        const bottomStickyEmpty = document.querySelector(`.make-app .tabs-bottom-sticky-empty.${tab}`);
                        const rect = bottomStickyEmpty!.getBoundingClientRect();
                        const elemTop = rect.top;
                        const elemBottom = rect.bottom;
                        const isVisibleOnPage = (elemTop >= 0)/* && (elemBottom <= window.innerHeight)*/;

                        element.style.display = isVisibleOnPage ? 'block' : 'none';
                        element.classList.toggle('sticky-active', !entry.isIntersecting);
                    });
                })
            },  {
                root: null,
                rootMargin: '0px',
                threshold: [0, .25, .5, .75, 1]
            });
            const target = document.querySelector(`.make-app .tabs-bottom-sticky-empty.${tab}`);
            if (target) {
                observerBottom.observe(target as Element);
            }
        });
    }
    let targetMusicPlayer = document.querySelector('.make-app .music-container .music-player-sticky-empty');
    if (targetMusicPlayer) {
        const observerMusicPlayer = new IntersectionObserver((entries, observer) => {
            entries.map((entry) => {
                if (entry.target.className == 'music-player-sticky-empty') {
                    Array.prototype.slice.call(document.querySelectorAll('.make-app .music-container .music-player')).map((element) => {
                        element.classList.toggle('sticky-active', !entry.isIntersecting)
                    });
                }
            })
        },  {
            root: null,
            rootMargin: '0px',
            threshold: 1
        });
        observerMusicPlayer.observe(document.querySelector('.make-app .music-container .music-player-sticky-empty') as Element);
    }
}